import { render, staticRenderFns } from "./drawer_edit.vue?vue&type=template&id=1dfe472d&scoped=true&"
import script from "./drawer_edit.vue?vue&type=script&lang=js&"
export * from "./drawer_edit.vue?vue&type=script&lang=js&"
import style0 from "./drawer_edit.vue?vue&type=style&index=0&id=1dfe472d&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1dfe472d",
  null
  
)

export default component.exports